import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import desc from './desc.vue';
import lyric from './lyric.vue';
import { ref, unref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Index'
  },
  __name: 'index',
  emits: ['generate-music'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const generateMode = ref('lyric');
    const modeRef = ref(null);
    /*
     *@Description: 根据信息生成音乐
     *@MethodAuthor: xiaohong
     *@Date: 2024-06-27 16:40:16
     */
    function generateMusic() {
      emits('generate-music', {
        formData: unref(modeRef)?.formData
      });
    }
    return (_ctx, _cache) => {
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_button = _resolveComponent("el-button");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      return _openBlock(), _createBlock(_component_ContentWrap, {
        class: "w-300px h-full mb-[0!important]"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: generateMode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => generateMode.value = $event),
          class: "mb-15px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_button, {
            value: "desc"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 描述模式 ")])),
            _: 1
          }), _createVNode(_component_el_radio_button, {
            value: "lyric"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" 歌词模式 ")])),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), (_openBlock(), _createBlock(_resolveDynamicComponent(generateMode.value === 'desc' ? desc : lyric), {
          ref_key: "modeRef",
          ref: modeRef
        }, null, 512)), _createVNode(_component_el_button, {
          type: "primary",
          round: "",
          class: "w-full",
          onClick: generateMusic
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" 创作音乐 ")])),
          _: 1
        })]),
        _: 1
      });
    };
  }
});